<div class="fcfs-modal d-flex flex-column">
  <span [innerHTML]="'save.fcfsModalHeader'| translate"></span>
  <span [innerHTML]="'save.fcfsModalMessage'| translate  : {agentName : agentName}" class="op-mt-16"></span>
  <div class="d-flex justify-content-end op-mt-8" (click)="emitService.emit(true);activeModal.close();">
    <button [innerHTML]="'common.close' | translate"></button>
  </div>
</div>
